module.exports = __webpack_public_path__ + "img/account_circle@2x.d57d397.png";